<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Performance-Analysis-Agent') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" :label="$t('Search')"
                append-icon="search"></v-text-field>
                <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
<!-- MAIL GÖNDER DIALOG -->
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
          <v-container fluid>
            <v-layout row wrap>

              <v-flex pb-3 xs12 sm12 md12>
                <v-card flat>
                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
                    <v-layout row wrap>
                      <v-flex pb-3 xs12 sm12 md12>
                        <v-card flat>
                          <v-layout row wrap>

                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp :etiket="$t('Date')" :detaygizle="false"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 pt-2 md2>
                              <tarihcomp :etiket="$t('Date')" :detaygizle="false"
                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                                v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                            </v-flex>




                            <v-flex pt-2>
                              <v-layout align-center="">
                                <div v-if="load1">
                                  <v-btn color="info" @click="getList()" fab small="" dark>
                                    <v-icon>search</v-icon>
                                  </v-btn>
                                </div>
                                <div v-if="progress">
                                  <v-layout align-center="">
                                    <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                                  </v-layout>
                                </div>
                                <v-badge color="white" :overlap="true">
                                  <template v-slot:badge>
                                    <v-icon v-if="filtrevarmi" large color="green">
                                      check_circle_outline </v-icon>
                                  </template>

                                  <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                                    @click="filtrele()" color="info" fab dark>
                                    <v-icon>filter_list</v-icon>
                                  </v-btn>
                                  <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                    <span>{{$t('Add-Search-Filter')}}</span>
                                  </v-tooltip>



                                </v-badge>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>
                  </v-form>

                </v-card>
              </v-flex>

              <v-flex xs12 v-if="kayitvarmi" sm12 md12 pb-3>
                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-flex xs12 sm12>
                          <v-card flat>
                            <v-data-table :headers="headersbaslik" :rows-per-page-items=[20,50,100,200]
                              :items="itemssatis" :search="searchsatilanbilet">
                              <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                              <template slot="items" slot-scope="props">
                                <tr item>
                                  <td v-for="kayit in props.item" :key="kayit.id" class="text-xs-left"> {{kayit}} </td>
                                </tr>
                              </template>
                              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                 {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                              </v-alert>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="350px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">
                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                              <havayollaritumlistecomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaritumlistecomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <masrafmerkezicomp v-model="Rapor.Masraf"></masrafmerkezicomp>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-text-field :label="$t('Day-Interval')" mask="######" v-model="Rapor.GunAralik"></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <v-radio-group v-model="Rapor.BiletTip" :label="$t('Ticket-Type')" column>
                                <v-radio :label="$t('All')" value='0'></v-radio>
                                <v-radio :label="$t('Domestic-Line')" value='1'></v-radio>
                                <v-radio :label="$t('International-Line')" value='2'></v-radio>
                              </v-radio-group>
                            </v-flex>

                             <v-flex xs12 sm12 md12>
                            <v-layout justify-space-between column>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-layout>
                          </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import havayollaritumlistecomp from "@/components/app/customcomp/havayollaritumlistecomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  export default {
    data() {
      return {
         mailDialog: false,
        mailValid: false,
        mailLoading: false,
        mailPayload: {
          To: "",
          AgencyName: "",
          DocType: "Kesen Kişi Performans Raporu - Performance Analysis of Ticket Agent", 
          AgentFullName: "",
          CustomBody: ""
        },
        rules: {
          required: v => !!v || 'Zorunlu alan',
          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
        },
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        kayitvarmi: false,
        referansitems: [],
        search: '',
        searchsatilanbilet: null,
        tarihitems: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010,
          2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028,
          2029, 2030
        ],
        headersbaslik: [],
        genelToplamlar: {
          ToplamAdatAlacak: 0,
          ToplamAdatBorc: 0,
          ToplamGun: 0,
          VadeFarki: 0
        },
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        Rapor: {

          BaslangicTarih: null,
          BitisTarih: null,
          GunAralik: 7,
          BiletTip: '0', // 0 : Hepsi, 1 : İç Hat, 2 : Dış Hat
          HavayoluKodu: null,
          Masraf: null,


          Tarih: null,
          SirketKodu: null,
          Cari: {
            Kod: null,
          },

          Gruplar: [],
          NoGruplar: [],
          GunSayi: null,
          RaporTip: '0', // 0 : Gun Aralıklı, 1 : aylık , 2 : 15 gunluk : 3 : Haftalık
          DonemSayisi: null,
          IleriGeri: false, // false : Ileri , true : Geri
          CoperEvrak: false
        },
        valid: true,
        tumsirketler: '',
        loadingana: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        statecari: [],
        searchcari: '',
        statecariana: [],
        searchcariana: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],

        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        this.Rapor.Yil = helpers.getYear();

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
        var params3 = {
          CompanyCode: credentials.SirketKodu
        }


        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapgurubu = response.body
          this.nohesapgrubu = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })



        this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.evraktipi = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-doctype'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-doctype'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute
              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      yuzdeinput,
      havayollaritumlistecomp,
      masrafmerkezicomp,
      yetkidialog
    },
    watch: {
    },
    methods: {
  openMailDialog() {
    if (this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
      this.$refs.mailForm.resetValidation();
    }

    const pageDocType = "Kesen Kişi Performans Analizi - Salesman Performance Analysis";
    if (!this.mailPayload.DocType || this.mailPayload.DocType === "Kesen Kişi Performans Raporu - Performance Analysis of Ticket Agent") {
      this.mailPayload.DocType = pageDocType;
    }

    this.mailDialog = true;
  },

  closeMailDialog() {
    this.mailDialog = false;
  },

  sendMail() {
    const _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {
      return;
    }

    const bas = (_this.Rapor && _this.Rapor.BaslangicTarih) ? new Date(_this.Rapor.BaslangicTarih) : null;
    const bit = (_this.Rapor && _this.Rapor.BitisTarih) ? new Date(_this.Rapor.BitisTarih) : null;
    if (!(bas && bit) || bas > bit) {
      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');
      _this.snackbar = true;
      return;
    }

    const credentialsRaw = window.localStorage.getItem('credentials');
    const credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
    const companyCode = _this.tumsirketler === true
      ? '0'
      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    const havayoluKodu = (_this.havayolubil && _this.havayolubil.havayolukodu) ? _this.havayolubil.havayolukodu : null;

    const inputObj = {
      SirketKodu: companyCode,
      BaslangicTarih: _this.Rapor.BaslangicTarih,
      BitisTarih: _this.Rapor.BitisTarih,
      GunAralik: _this.Rapor.GunAralik,
      BiletTip: _this.Rapor.BiletTip,        
      HavayoluKodu: havayoluKodu,
      Masraf: _this.Rapor.Masraf
    };

    const mailObj = {
      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",
      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",
      DocType: _this.mailPayload && _this.mailPayload.DocType
        ? _this.mailPayload.DocType
        : "Kesen Kişi Performans Raporu - Performance Analysis of Ticket Agent",
      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",
      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""
    };

    const payload = {
      Input: inputObj,
      Mail: mailObj
    };

    _this.mailLoading = true;

    const endpoint = auth.API_URL + 'api/TicketReport/MailGonderKesenKisiAnalizExcel';

    _this.$http.post(
      endpoint,
      payload,
      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
    ).then(function () {
      _this.mailLoading = false;
      _this.mailDialog = false;
      _this.text1 = 'Mail gönderildi.';
      _this.snackbar = true;
    }, function (err) {
      _this.mailLoading = false;
      const body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
      const msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';
      _this.text1 = msg;
      _this.snackbar = true;
    });
  },


      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      tarihformat
    }
  }

  function tarihformat(t) {

    if (t != null) {
      var a = t.split("/")
      var tarih1 = a[0].replace('00:00:00', '') + " " + a[1].replace('00:00:00', '')
      return tarih1;
    } else {
      return null
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgrubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      }
    })


  }


  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.Rapor.SirketKodu = null
    this.Rapor.BiletTip = '0'
    this.Rapor.GunAralik = 7
    this.Rapor.Masraf = null
    this.Rapor.HavayoluKodu = null
    this.havayolubil.havayolukodu = null
    this.tumsirketler = ''
  }




  function getList() {

    if (this.$refs.formgunluksatis.validate()) {
      this.kayitvarmi = false
      this.progress = true
      this.load1 = false
      this.headersbaslik = []
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu

      var params = this.Rapor

      this.$http.post(auth.API_URL + 'api/TicketReport/SalesmanPerformanceReport', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        if (response.body.DetayList.length > 0) {

          var heeeder = [];

          var ind = {
            text: this.$t('Date-Interval'),
            value: 'aTarih',
          }

          heeeder.push(ind)



          //tekrar eden alanları dinamik olarak alalım

          var ilk = response.body.DetayList

          Object.keys(ilk).forEach(function (key) {


            var ind = {
              text: ilk[key].KesenKisi,
              value: 'b' + key
            }
            heeeder.push(ind)

          });


          var ind = {
            text: this.$t('Total'),
            value: 'cToplam',
          }

          heeeder.push(ind)

          this.kayitvarmi = true
          this.headersbaslik = heeeder
          this.itemssatis = []
          var kayitsayisi = response.body.DetayList.length
          var donemsayisi = response.body.DetayList[0].DonemList.length
          for (var i = 0; i < donemsayisi; i++) {
            var object = {}
            var tarih = tarihformat(response.body.DetayList[0].DonemList[i].Donem)
            object['aTarih'] = tarih
            var yataytoplam = 0
            for (var j = 0; j < kayitsayisi; j++) {
              object['b' + j] = response.body.DetayList[j].DonemList[i].Adet
              yataytoplam = yataytoplam + response.body.DetayList[j].DonemList[i].Adet
            }
            object['c' + i] = yataytoplam
            this.itemssatis.push(object)
          }
          var objecttoplam = {}
          objecttoplam['aTarih'] = this.$t('Grand-Total')
          var dikeytoplam = 0
          for (var j = 0; j < kayitsayisi; j++) {
            var toplam = 0;
            response.body.DetayList[j].DonemList.forEach(element => {
              toplam = toplam + element.Adet;
            });
            objecttoplam['b' + j] = toplam
            dikeytoplam = dikeytoplam + toplam
          }
          objecttoplam['c0'] = dikeytoplam
          this.itemssatis.push(objecttoplam)
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = this.$t('No-Records-Found')
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-SalesmanPerformanceReport'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable-SalesmanPerformanceReport'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }
      })

    }
  }



  function getListHtml() {
    if (this.$refs.formgunluksatis.validate()) {
      this.kayitvarmi = false
      this.progress = true
      this.load1 = false
      this.headersbaslik = []
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var lang = localStorage.getItem('lang')
      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu

      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketReport/SalesmanPerformanceReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true
          if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> KESEN KİŞİ PERFORMANS ANALİZİ </title>','<title> CUTTING PERSON PERFORMANCE ANALYSIS </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>KESEN KİŞİ PERFORMANS ANALİZİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>CUTTING PERSON PERFORMANCE ANALYSIS</font>")
             bodyhtml=bodyhtml.toString().replace("Hava Yolu Code :","Airline Code :")
             bodyhtml=bodyhtml.toString().replace("Bilet No :","Ticket No :")
             bodyhtml=bodyhtml.toString().replace("HY Kodu","Airline Code")
             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")
             bodyhtml=bodyhtml.toString().replace("Uçuş Type","Flight Type")
             bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")
             bodyhtml=bodyhtml.toString().replace("Void Tarihi","Void Date")
             bodyhtml=bodyhtml.toString().replace("Satış Tarihi","Sales Date")
             bodyhtml=bodyhtml.toString().replace("Kesim Tarihi","Cutting Date")
             bodyhtml=bodyhtml.toString().replace("Bilet Amountı","Ticket Amount")
             bodyhtml=bodyhtml.toString().replace("Vergi Tutarı","Tax Amount")
             bodyhtml=bodyhtml.toString().replace("Discount Tutarı","Discount Amount")
            
             response.bodyText=bodyhtml;
             
          }
          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "KesenPerformans.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    }
  }



  function getListExcel() {


    if (this.$refs.formgunluksatis.validate()) {
      this.kayitvarmi = false
      this.progress = true
      this.load1 = false
      this.headersbaslik = []
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu

      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketReport/SalesmanPerformanceReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "KesenPerformans.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }
  }


  function beforeMount() {
  }

</script>

<style>
</style>